import { Injectable } from '@angular/core';
import { LoadMFESrvAbstract } from '@base/abstracts/services/load-mfe.abstract';
import { removeScript } from '@base/utils';
import { environment } from 'environments/environment';

/**
 * Owns the shared Informa Floorplan script lease.
 *
 * Multiple modal/page hosts can coexist while an entity modal is open. The
 * script is removed only after the last host releases its lease.
 */
@Injectable({ providedIn: 'root' })
export class InformaFloorplanScriptService {
  private activeConsumers = 0;
  private pendingLoad: Promise<void> | null = null;

  async acquire(loadMfeSrv: LoadMFESrvAbstract): Promise<void> {
    if (!this.pendingLoad) {
      this.pendingLoad = loadMfeSrv.loadInformaFloorplan().finally(() => {
        this.pendingLoad = null;
      });
    }

    try {
      await this.pendingLoad;
    } catch (error) {
      removeScript(environment.informaFloorplan);
      throw error;
    }

    this.activeConsumers += 1;
  }

  release(): void {
    if (this.activeConsumers === 0) return;

    this.activeConsumers -= 1;
    if (this.activeConsumers === 0) {
      removeScript(environment.informaFloorplan);
    }
  }

  get consumerCount(): number {
    return this.activeConsumers;
  }
}
